import { gql } from '@apollo/client'

import { FRAGMENT_IMAGE, FRAGMENT_PERSON_INFO } from '../../../queries'
import { isPreview } from '../../../services/contenful'

export const FRAGMENT_POST = gql`
  fragment Post on BlogPost {
    author {
      ...PersonInfo
    }
    excerpt
    featuredImage {
      ...Image
    }
    listTitle
    slug
    title
    publishDate
    postType
    sys {
      id
    }
    seoTitle
    seoDescription
  }
  ${FRAGMENT_IMAGE}
  ${FRAGMENT_PERSON_INFO}
`

export const GET_POSTS = gql`
  query BlogPosts {
    blogPostCollection(order: publishDate_DESC, preview: ${isPreview}) {
      items {
        ...Post
      }
    }
  }
  ${FRAGMENT_POST}
`

export const GET_POST_ID = gql`
  query ($slug: String!) {
    blogPostCollection(where: { slug: $slug }, preview: ${isPreview}) {
      items {
        sys {
          id
        }
      }
    }
  }
`

export const GET_POST = gql`
  query ($id: String!) {
    blogPost(id: $id, preview: ${isPreview}) {
        body {
          json
          links {
            assets {
              block {
                sys {
                  id
                }
                title
                url
                contentType
                width
                height
              }
            }
          }
        }
        video
        participantsCollection(limit: 20) {
          items {
            ...PersonInfo
          }
        }
        ...Post
    }
  }
  ${FRAGMENT_POST}
  ${FRAGMENT_PERSON_INFO}
`
